import {createContext, useContext} from 'react';

export const PageContainerContext = createContext(null);

export const usePageContainerContext = () => {
  return useContext(PageContainerContext);
};
